import { OptionData } from "components/DesignSystem/Combobox/Combobox";

export const findOptionByValue = <T extends OptionData>(
  options: T[],
  value: string
): T | null => options.find((option) => option.value === value) ?? null;
